<template>
  <div>
    <modal :modal-size="true" :image-modal="true" :name="'modal-image'">
      <button
        slot="buttons"
        v-show="!isFirstImage"
        class="image-module-button-left"
        type="button"
        aria-label="Prev image"
        @click="showPrevImage()"
      >
        <i class="icon-chevron-left" />
      </button>
      <button
        slot="buttons"
        v-show="!isLastImage"
        class="image-module-button-right"
        type="button"
        aria-label="Next image"
        @click="showNextImage()"
      >
        <i class="icon-chevron-right" />
      </button>
      <div slot="content" class="table-box">
        <img class="popup-image" :alt="productName" :src="getThumbnailPath(getCurrentZoomImage, 2000, 2000)">
      </div>
    </modal>
    <div class="media-gallery-mobile">
      <div v-if="productSold" class="gallery-sold-label">
        {{ $t(soldLabel || 'Sold') }}
      </div>
      <transition name="fade">
        <div>
          <div v-show="getCurrentImage && getCurrentImage.vimeoId">
            <no-ssr>
              <vue-vimeo-player v-if="vimeoId" ref="player" class="visible-xs vimeo-video" :video-id="vimeoId" @ready="onReady" />
            </no-ssr>
          </div>
        <img
          v-show="getCurrentImage && !getCurrentImage.vimeoId && hideImageAtIndex"
          :src="getCurrentImage.src"
          width="467"
          height="700"
          @click="$bus.$emit('modal-show', 'modal-image')"
          :alt="getCurrentImage.alt || productName | htmlDecode"
          :title="productName | htmlDecode"
        >
      </div>
      </transition>
      <div v-for="(images, index) in gallery" :key="images.src">
        <product-video
          v-if="images.video && (index === currentShowed)"
          v-bind="images.video"
          :index="index"
          @video-started="onVideoStarted"
        />
      </div>
      <button
        v-show="!isFirstImage"
        class="nav-button prev"
        type="button"
        aria-label="Prev image"
        @click="showPrevImage()"
      >
        <i class="icon-chevron-left" />
      </button>
      <button
        v-show="!isLastImage"
        class="nav-button next"
        type="button"
        aria-label="Next image"
        @click="showNextImage()"
      >
        <i class="icon-chevron-right" />
      </button>
      <i
        class="zoom-in icon-search-alt p15 pointer cl-main-black"
        @click="openOverlay"
      />
    </div>
  </div>
</template>

<script>
import ProductVideo from './ProductVideo'
import Modal from 'theme/components/core/Modal.vue'
import { getThumbnailPath as _thumbnailHelper } from '@vue-storefront/core/helpers'
import NoSSR from 'vue-no-ssr'
import { vueVimeoPlayer } from 'vue-vimeo-player'

export default {
  components: {
    ProductVideo,
    Modal,
    vueVimeoPlayer,
    'no-ssr': NoSSR,
  },
  props: {
    productName: {
      type: String,
      default: ''
    },
    productSold: {
      type: Boolean,
      default: false
    },
    soldLabel: {
      type: String,
      default: 'Sold'
    },
    gallery: {
      type: Array,
      required: true
    },
    vimeoId: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      hideImageAtIndex: true,
      currentShowed: 0,
      playerReady: true,
    }
  },
  mounted () {
    this.$bus.$on('product-after-load', this.resetImage);
  },
  destroyed () {
    this.$bus.$off('product-after-load', this.resetImage);
  },
  computed: {
    initGallery () {
      return this.vimeoId ? [{ vimeoId: this.vimeoId }, ...this.gallery] : this.gallery
    },
    getCurrentImage () {
      return this.initGallery.length && this.initGallery[this.currentShowed]
    },
    getCurrentZoomImage () {
      let imageLink = this.initGallery.length && this.initGallery[this.currentShowed]
      return imageLink && imageLink.src && imageLink.src.split('resize/product')[1]
    },
    isLastImage () {
      return (this.initGallery.length - 1) === this.currentShowed
    },
    isFirstImage () {
      return this.currentShowed === 0
    }
  },
  methods: {
    getThumbnailPath (url, width, height) {
      return this.getThumbnail(url, width, height, 'product')
    },
    onVideoStarted (index) {
      this.hideImageAtIndex = false
    },
    pageChange (index) {
      this.currentShowed = index
      this.hideImageAtIndex = null
    },
    resetImage () {
      this.currentShowed = 0
    },
    showNextImage () {
      this.hideImageAtIndex = true
      this.currentShowed++
      this.pause()
    },
    showPrevImage () {
      this.currentShowed--
      this.hideImageAtIndex = true
      this.pause()
    },
    openOverlay () {
      this.$emit('toggle', this.currentShowed)
    },
    onReady () {
      this.playerReady = true
    },
    play () {
      this.$refs.player.play()
    },
    pause () {
      if (!this.$refs.player) return 
      this.$refs.player.pause()
    },
    
  }
}
</script>

<style lang="scss" scoped>
.mobile-gallery-dots {
  position: absolute;
  left: 50%;
  bottom: 3%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: row;
}
.active-dot{
  background-color: rgb(113, 113, 113)!important;
}
.dot {
  width: 10px;
  margin: 5px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(240, 240, 240);
}
.image {
  background-color: #faf7f2;
}
.popup-image {
    background-size: contain;
    position: absolute;
    background-color: #fafafa;
    overflow: scroll;
    left: 0;
    -webkit-overflow-scrolling:touch;
}

.image-module-button-left {
  bottom: 4%;
  background: #fff;
  padding: 10px;
  border: none;
  position: absolute;
  left: calc(25% - 22px);
  z-index: 13;
  color: #707070;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;;
}
.image-module-button-right {
  bottom: 4%;
  background: #fff;
  padding: 10px;
  border: none;
  position: absolute;
  left: calc(75% - 22px);
  z-index: 13;
  color: #707070;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;;
}
.media-gallery-mobile {
  @media (min-width: 768px) {
    display: none;
  }
  position: relative;
  width: 100%;
  max-width: 100%;
  padding-bottom: 150%;
  .nav-button {
    &.prev {
      left: 0;
    }
    &.next {
      right: 0;
    }
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    color: #707070;
    justify-content: center;
    position: absolute;
    top: 50%;
    background-color: initial;
    border: 1px solid #707070;
    border-radius: 50%;
    @media (max-width: 767px) {
      width: 45px;
      height: 45px;
    }
    .icon-chevron-right {
      font-size: 40px;
      padding-left: 2px;
    }
  }
  img {
    object-fit: contain;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .vimeo-video {
  /deep/ iframe {
    object-fit: contain;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
  .zoom-in {
    font-size: 35px;
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
.gallery-sold-label {
  cursor: default;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 5;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.55px;
  color: #FFFFFF;
  background-color: #000;
  border: 1px solid #FFFFFF;
  border-radius: 3px;
  padding: 5px 12px;
  text-transform: uppercase;
}
</style>
